export default __webpack_public_path__ + "success-tick-icon.svg";